import React, { Component } from 'react';
import { HashRouter, Route, Switch} from 'react-router-dom';

import MainTemplate from "./components/mainLayout/template/mainTemplate";
import login from "./components/login/login";
import notFound from "./components/notFound/notFound";
import home from "./components/home/home";
import dashboardSanzione from "./components/dashboard/dashboardSanzione/dashboardSanzione";
import dashboardMappature from "./components/dashboard/dashboardMappature/dashboardMappature";
import detailSanzione from "./components/detail/detailSanzione/detailSanzione";
import Workinprogress from './components/notFound/workinprogress';
import ProtectedRoute from "./common/protectedRoute/protectedRoute";
import ProtectedRouteAdmin from "./common/protectedRoute/protectedRouteAdmin";
import {ProtectedRouteKeyHelp, ProtectedRouteKeyMappatura} from "./common/protectedRoute/protectedRouteKey";
import Tickets from "./components/tickets/tickets";
import 'bootstrap/dist/js/bootstrap.bundle';
import manageProfile from './components/dashboard/dashboardUser/manageProfile';
import detailUser from './components/detail/detailUser/detailUser';
import detailLoginUser from './components/detail/detailUser/detailLoginUser';
import RicercaSanzione from './components/ricercaSanzione/ricercaSanzione';
import RecezionePagamento from './components/ricercaSanzione/RecezionePagamento';
import TipologiaSanzione from './components/dashboard/dashboardTipologiaSanzione/dashboardTipologiaSanzione';
import ImpostazioneSaznione from './components/dashboard/dashboardImpostazioneSaznione/dashboardImpostazioneSaznione'
import dashboardRecidivi from './components/dashboard/dashboardRecidivi/dashboardRecidivi'
import Praxy from './components/notFound/praxy';
import dashboardPayroll from './components/dashboard/dashboardPayroll/dashboardPayroll';
import RicercaSanzioneR from './components/ricercaSanzione/RicercaSanzioneR';
import EsitoPagamento from './components/ricercaSanzione/redirectPagamento/EsitoPagamento';
import EsportaSpacchettatoSanzioni from './components/esportaSpacchettato/EsportaSpacchettatoSanzioni';
import ImportaSanzioni from './components/importaSanzioni/ImportaSanzioni';
import Terms from './components/terms/Terms';
import RicercaRapida from './components/dashboard/dashboardRicercaRapida/RicercaRapida';
import TipoDocumento from './components/dashboard/dashboardTipoDocumento/DashboardTipoDocumento';
import LineaMezzo from './components/dashboard/dashboardLineaMezzo/DashboardLineaMezzo';
import DashboardTicketWrapper from './pages/dashboard-ticket/DashboardTicket';
import DetailTicketWrapper from './pages/detail-ticket/DetailTicket';
import ProtectedRouteUsers from './common/protectedRoute/protectedRouteUser';

class App extends Component {
   constructor(props){
      super(props);
   }

   componentDidMount(){
      document.title = process.env.REACT_APP_TITLE
   }


   render() { 
      return (
         <HashRouter basename={"/"}>
            <MainTemplate>
               <Switch>
                  <Route exact path='/' component={login}/>
                  <Route exact path='/login' component={login}/>


                  <ProtectedRoute exact path='/home' component={home}/>
                  <ProtectedRoute exact path='/detailSanzione' component={detailSanzione}/>
                  <ProtectedRoute exact path='/dashboardSanzioni' component={dashboardSanzione}/>
                  <ProtectedRouteKeyMappatura exact path='/dashboardMappature' component={dashboardMappature}/>
                  <ProtectedRoute exact path="/esportaSpacchettatoSanzioni" component={EsportaSpacchettatoSanzioni}/>
                  <ProtectedRoute exact path="/importaSanzioni" component={ImportaSanzioni}/>
                  {/* <ProtectedRouteAdmin exact path='/manageProfile' component={manageProfile}/>
                  <ProtectedRouteAdmin exact path='/detailProfile' component={detailUser}/> */}
                  <ProtectedRouteUsers exact path='/manageProfile' component={manageProfile}/>
                  <ProtectedRouteUsers exact path='/detailProfile' component={detailUser}/>
                  <ProtectedRoute exact path='/profile' component={detailLoginUser}/>

                  <Route exact path='*/ricercaSanzione' component={RicercaSanzioneR}/>
                  <Route exact path='*/responsepagamento' component={EsitoPagamento}/>
                  <Route exact path='*/RecezionePagamento' component={RecezionePagamento}/>
                  
                  <ProtectedRouteAdmin exact path='*/impostazioneSanzione' component={ImpostazioneSaznione}/>
                  <ProtectedRouteAdmin exact path='*/TipologiaSanzione' component={TipologiaSanzione}/>
                  <ProtectedRouteAdmin exact path='*/tipoDocumento' component={TipoDocumento}/>
                  <ProtectedRouteAdmin exact path='*/lineaMezzo' component={LineaMezzo}/>
                  <ProtectedRoute exact path='*/Recidivi' component={dashboardRecidivi}/>
                  <ProtectedRoute exact path='/RicercaRapida' component={RicercaRapida}/>
                  <ProtectedRoute exact path="*/tickets" component={DashboardTicketWrapper}/>
                  <ProtectedRoute exact path='*/ticketDetail' component={DetailTicketWrapper}/>
                  
                  
                  <ProtectedRouteKeyHelp exact path='*/tickets' component={Tickets}/>
                  <Route exact path='*/Privacy' component={Praxy}/>
                  <Route exact path='*' component={notFound}/>
               </Switch>
            </MainTemplate>
         </HashRouter>
      );
   }
}
export default App;


{/* <ProtectedRoute exact path='/recidivi' component={Workinprogress}/> */}